import { Component, Input, OnInit } from '@angular/core';
import { SUB_PROJECT_TYPES } from 'src/app/model/project/sub-project';
import { ToDoItem } from '../../../../../services/immo-ip-placer-offline-changes/model/to-do-item';
import { ImmoBillingDetailProduct } from '../../../overview/billing-detail/model/immo-billing-detail-product';
import { ImmoBillingDetailSubProject } from '../../../overview/billing-detail/model/immo-billing-detail-sub-project';
import IPBoardPlacement from 'src/app/model/product/ip-board/ip-board-placement';

@Component({
  selector: 'immo-ip-placer-project-completion',
  templateUrl: './immo-ip-placer-project-completion.component.html',
  styleUrls: ['./immo-ip-placer-project-completion.component.scss'],
})
export class ImmoIPPlacerProjectCompletionComponent implements OnInit {
  @Input()
  subProject: ImmoBillingDetailSubProject;
  @Input()
  baseProject: ImmoBillingDetailSubProject;

  firstIPBoardWrapper: IpBoardWrapper;
  subProjectToDoItems: SubProjectToDoItems;

  SUB_PROJECT_TYPES = SUB_PROJECT_TYPES;

  ngOnInit() {
    const firstProduct: ImmoBillingDetailProduct =
      this.subProject.project.products[0];
    if (this.subProject.expectedType === SUB_PROJECT_TYPES.BASE_PROJECT) {
      this.firstIPBoardWrapper = this.constructWrapper(firstProduct);
    } else {
      this.subProjectToDoItems = this.constructAdjustment(firstProduct);
    }
  }

  private constructWrapper(product: ImmoBillingDetailProduct): IpBoardWrapper {
    const wrapper = new IpBoardWrapper();
    wrapper.ipBoard = product;
    const ipBoardPlacement = <IPBoardPlacement>product.productPlacement;
    const checkboxValue: boolean =
      product.productPlacement != null &&
      product.productPlacement.executionComplete;

    if (product.title) {
      wrapper.leftTitle = this.constructToDoItem('Titel links', checkboxValue);
    }
    if (product.titleRight) {
      wrapper.rightTitle = this.constructToDoItem(
        'Titel rechts',
        checkboxValue
      );
    }
    if (product.phoneNumber) {
      wrapper.leftPhoneNumber = this.constructToDoItem(
        'Telefoon links',
        checkboxValue
      );
    }
    if (product.phoneNumberRight) {
      wrapper.rightPhoneNumber = this.constructToDoItem(
        'Telefoon rechts',
        checkboxValue
      );
    }
    if (ipBoardPlacement.extraHeight) {
      wrapper.extraHeight = this.constructToDoItem(
        'Extra materiaal',
        checkboxValue
      );
    }
    if (product.text || product.textRight) {
      wrapper.text = this.constructToDoItem('Tekst', checkboxValue);
    }
    if (product.immoscoopLogo) {
      wrapper.immoscoop = this.constructToDoItem('Immoscoop', checkboxValue);
    }
    if (product.spottoLogo) {
      wrapper.spotto = this.constructToDoItem('Spotto', checkboxValue);
    }

    wrapper.placed = this.constructToDoItem('Geplaatst', checkboxValue);

    if (product.stickerText) {
      wrapper.sticker = this.constructToDoItem('Sticker', checkboxValue);
    }
    if (this.includeExtras(ipBoardPlacement)) {
      wrapper.extras = this.constructToDoItem(`Extra's`, checkboxValue);
    }

    this.processPoleColor(product, wrapper, checkboxValue);

    return wrapper;
  }

  private processPoleColor(
    product: ImmoBillingDetailProduct,
    wrapper: IpBoardWrapper,
    checkboxValue: boolean
  ): void {
    if (
      product.boardPart.sign != null &&
      product.boardPart.sign.poleColor != null
    ) {
      wrapper.poleColor = this.constructToDoItem(
        product.boardPart.sign.poleColor.label,
        true
      );
    } else if (product.poleColor != null) {
      wrapper.poleColor = this.constructToDoItem(
        product.poleColor.label,
        checkboxValue
      );
    }
  }

  private constructToDoItem(label: string, done: boolean): ToDoItem {
    return {
      label: label,
      done: done,
    };
  }

  private includeExtras(ipBoardPlacement: IPBoardPlacement): boolean {
    return (
      (this.subProject.projectPlacement != null &&
        this.subProject.projectPlacement.secondBoard != null) ||
      (ipBoardPlacement != null && ipBoardPlacement.arrows != null)
    );
  }

  private constructAdjustment(
    product: ImmoBillingDetailProduct
  ): SubProjectToDoItems {
    const result = new SubProjectToDoItems();
    const checkboxValue =
      this.subProject.projectPlacement != null &&
      this.subProject.projectPlacement.placementDone;

    if (product.productPlacement) {
      result.completed = this.constructToDoItem(
        this.getCompletedToDoItemLabel(this.subProject.expectedType),
        checkboxValue
      );
    }
    if (
      this.subProject.expectedType === SUB_PROJECT_TYPES.SOLDRENTED &&
      this.baseProject != null &&
      this.baseProject.projectPlacement != null &&
      this.baseProject.projectPlacement.secondBoard != null
    ) {
      result.extras = this.constructToDoItem(
        'Sticker aangebracht op tweede bord',
        checkboxValue
      );
    }

    return result;
  }

  private getCompletedToDoItemLabel(type: string): string {
    switch (type) {
      case SUB_PROJECT_TYPES.ADJUSTMENT:
        return 'Aanpassing klaar';
      case SUB_PROJECT_TYPES.SOLDRENTED:
        return 'Sticker aangebracht';
      case SUB_PROJECT_TYPES.REPO:
        return 'Weggehaald';
      default:
        throw new Error(`invalid type: ${type}`);
    }
  }
}

class IpBoardWrapper {
  placed?: ToDoItem;
  immoscoop?: ToDoItem;
  spotto?: ToDoItem;
  poleColor?: ToDoItem;
  leftTitle?: ToDoItem;
  rightTitle?: ToDoItem;
  leftPhoneNumber?: ToDoItem;
  rightPhoneNumber?: ToDoItem;
  text?: ToDoItem;
  sticker?: ToDoItem;
  extras?: ToDoItem;
  extraBoard?: ToDoItem;
  extraHeight?: ToDoItem;

  ipBoard: ImmoBillingDetailProduct;
}

class SubProjectToDoItems {
  completed?: ToDoItem;
  stickerInfo?: ToDoItem;
  extras?: ToDoItem;
}
